
(function timePickerDirectiveDefinition() {

    function createTimepickerFactory(template, directive) {
        return function timePickerDirectiveFactory() {
            return {
                restrict: 'E',
                templateUrl: template,
                scope: {
                    modelo: '=ngModel',
                    clearText: '@',
                    minTime: '&',
                    maxTime: '&',
                    showMeridian: '@',
                    isOpen: '=?'
                },
                require: ['ngModel', directive],
                controller: ['$scope', '$element',
                    function timePickerController(scope, element) {

                        scope.isOpen = false;

                        scope.clear = function () {
                            scope.oldModelo = scope.modelo;
                            scope.modelo = undefined;
                        };

                        scope.restore = function () {
                            if (scope.oldModelo && scope.modelo == undefined) {
                                scope.modelo = scope.oldModelo;
                            } else if (scope.modelo == null) {
                                var date = new Date();
                                date.setHours(0);
                                date.setMinutes(0);
                                date.setSeconds(0);
                                date.setMilliseconds(0);
                                scope.modelo = date;
                            }
                        };

                        this.openPicker = function openPicker() {
                            scope.restore();
                            scope.isOpen = true;
                        };

                        this.hidePicker = function hidePicker() {
                            scope.isOpen = false;
                        };
                    }
                ],
                link: function (scope, elem, attrs, ctrls) {

                    var ngModel = ctrls[0];
                    scope.showClear = attrs.showClear !== undefined;
                    
                    if (attrs.name) {
                        elem.find('input').attr('name', attrs.name);
                    }


                    scope.openPicker = function openPicker($event) {
                        ctrls[1].openPicker();
                        $event.preventDefault();
                        $event.stopPropagation();
                    };
                    
                    ngModel.$validators.minValue = function (modelValue, viewValue) {
                        var value = modelValue;
                        var min = scope.minTime();
                        if (value && min) {
                            return min <= value;
                        }
                        return true;
                    };

                    scope.$watch(scope.minTime, function () {
                        ngModel.$validate();
                    });

                    ngModel.$validators.maxValue = function (modelValue, viewValue) {
                        var value = modelValue;
                        var max = scope.maxTime();
                        if (value && max) {
                            return max >= value;
                        }
                        return true;
                    };

                    scope.$watch(scope.maxTime, function () {
                        ngModel.$validate();
                    });
                }
            };
        };
    }

    angular.module("TimePicker")
        .directive('popupTimepickerFormatter', function timePickerDirectiveFactory() {

            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, elem, attrs, ctrl) {
                    if (!ctrl)
                        return;

                    ctrl.$formatters.push(function(a) {
                        if (a)
                            return dateToTimeString(a, true);
                        return null;
                    });

                }
            };

        })
        .directive('smallPopupTimepicker', createTimepickerFactory('popup-timepicker-sm.html', 'smallPopupTimepicker'))
        .directive('popupTimepicker', createTimepickerFactory('popup-timepicker.html', 'popupTimepicker'))
        .run([
            "$templateCache", function timePickerTemplatesDefinition($templateCache) {
                $templateCache.put("popup-timepicker-popup.html",
                    '<div class="timepicker-popup">' +
                    '<timepicker ng-model="modelo"' +
                    'hour-step="1"' +
                    'minute-step="1"' +
                    'show-meridian="showMeridian"></timepicker>' +
                    '</div>' +
                    "");

                $templateCache.put("popup-timepicker.html",
                    '<div class="input-group">' +
                    '<span class="input-group-btn" ng-if="showClear"><a href="" class="btn btn-danger" ng-click="clear()" >{{"Clear" | translate}}</a></span>' +
                    '<input type="text" ng-click="openPicker($event)" ' +
                    'ng-model="modelo" popup-timepicker-formatter ' +
                    'class="form-control"' +
                    'readonly />' +
                    '<span class="input-group-btn">' +
                    '<a class="btn btn-default" ng-click="restore()" show-popup="\'popup-timepicker-popup.html\'" is-open="isOpen"><i class="glyphicon glyphicon-time"></i></a>' +
                    '</span>' +
                    "</div>");

                $templateCache.put("popup-timepicker-sm.html",
                    '<div class="input-group">' +
                    '<span class="input-group-btn" ng-if="showClear"><a href="" class="btn btn-danger btn-sm" ng-click="clear()" >{{"Clear" | translate}}</a></span>' +
                    '<input type="text" ng-click="openPicker($event)" ' +
                    'ng-model="modelo" popup-timepicker-formatter ' +
                    'class="form-control input-sm" ' +
                    'readonly />' +
                    '<span class="input-group-btn">' +
                    '<a class="btn btn-default btn-sm" ng-click="restore()" show-popup="\'popup-timepicker-popup.html\'" is-open="isOpen"><i class="glyphicon glyphicon-time"></i></a>' +
                    '</span>' +
                    "</div>");
            }
        ]);
})();
